<svelte:body on:item={put_item} on:reset={() => {components = {}; change();}} />
<script>
    import _ from 'lodash';
    import {network, parameter} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';


    import MaterialsList from "../../parts/MaterialsList.svelte";
    import {decode, encode} from "../../../helpers";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {

            let fetched = await network.fetch_tovar(item.idTovar)
            let json = JSON.parse(decode(fetched.ind3))
            fetchData = await fetch();
            components = json.components
            count.set(+item.quantity);
            //comment.set(item.comment);
            change();
        }
    };

    const fetch = async () => {
        let result = await network.fetch_data('Фурнитура', 'Фурнитура', '')

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let fetchData = fetch();

    let material_type = ''
    let material_sub = 'Ткань'
    let material_group = ''

    let search = '',
        components = {}, // выбор
        comment = parameter('comment', ''),
        count = parameter('count', 1);

    // расчёт стоимости
    const change = (async () => {
        if (Object.keys(components).length) {
            dispatch('lock', {state: false}); // блокировка перехода
        }

        let data = await fetchData;

        let result = {
            type: 'фурнитура',
            name: 'Фурнитура',
            subname: 'Фурнитура' ,
            title: 'Фурнитура',
                params: {
                    ind1: '',
                    ind2: '',
                    ind3: encode(JSON.stringify({components})),
                    ind4: 0,
                    ind5: 0,
                },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity: 1,
            materials: {},
            comment: $comment,
            vStrukture: 134
        };

        let title_addons = [];

         _.forEach(_.concat([], data.result, materials), function(item) {
            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0, percent = 0;

            if (components.hasOwnProperty(item.name)) {
                let edIzmer = item.edIzmer.length ? item.edIzmer : 'шт.';

                kolvo = +components[item.name]['count'];
                percent = +components[item.name]['percent'];

                title_addons.push(`${item.name} - ${kolvo}/${edIzmer}`)
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * item.price);
                price['opt'] = fixprecision(kolvo * item.price3);
                price['sebest'] = fixprecision(kolvo * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    percent,
                    spis: 0,
                    type: item.edIzmer,
                    oprice: {
                        rozn: fixprecision(+item.price),
                        opt: fixprecision(+item.price3),
                        sebest: fixprecision(+item.sebestomost),
                    },
                    quantity: 1,
                    price,
                    count: (+kolvo).toFixed(0)
                };
            }
        });


        result.title = `${result.title} | ${title_addons.join(', ')}`

        result.price.rozn = fixprecision(_.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn'));
        result.price.opt = fixprecision(_.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt'));
        result.price.sebest = fixprecision(_.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest'));

        dispatch('item', result);
    });

    change();

    let openedGroup = '';
    let tkan = '';
    const toggleGroup = (el) => {
        openedGroup = openedGroup !== el ? el : '';
    };

    const toggleComponent = (name, e) => {
        if (e.target.checked) {
            components[name] = {count: 1};

        } else {
            let { [name]: _, ...obj } = components;
            components = obj;
        }
    };

    const setComponentCount = (name, e) => {
        components[name]['count'] = +(e !== null ? e.target.value : 1);
    };

    let materials = [];

</script>

<style>
    .btn-group:not(:last-child) div {
        border-bottom: 0;
    }
    .btn-group div {
        border-radius: 0;
    }
    .btn-group:first-child div:first-of-type {
        border-top-left-radius: 6px;
    }
    .btn-group:first-child div:last-of-type {
        border-top-right-radius: 6px;
    }
    .btn-group:last-child div:first-of-type {
        border-bottom-left-radius: 6px;
    }
    .btn-group:last-child div:last-of-type {
        border-bottom-right-radius: 6px;
    }
</style>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    {@const categories = [ 'Вальс', ...new Set(data.result.filter((el) => !el.ind4.trim().length && !el.nameZvena.includes('вальс')).map((el) => el.ind3.trim().length ? el.ind3 : el.nameZvena))]}

    <!--<pre>{JSON.stringify(components, null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row mb-2 g-2">
            <div class="col-12">
                <label class="form-label">Вид:</label>
                <select class="form-control form-select" bind:value={material_type}>
                    {#each categories as category}
                        <option value={category}>{category}</option>
                    {/each}
                </select>
            </div>

            {#if material_type === 'Вальс'}
                {@const types = ['Ткань', ...new Set(data.result.filter((el) => el.ind3.toLowerCase().includes('вальс')).map((el) => el.ind3).filter((el) => Boolean(el)))]}

                <div class="col-12">
                    <label class="form-label">Тип:</label>
                    <select class="form-control form-select" bind:value={material_sub}>
                        {#each types as group}
                            <option value={group}>{group}</option>
                        {/each}
                    </select>
                </div>

                {#if material_sub === 'Ткань'}
                    {@const items = data.result.filter((el) => el.nameZvena === 'Ткани вальс')}
                    {@const inner = [...new Set(items.map((el) => el.ind1).filter((el) => Boolean(el)))]}

                    {#if inner.length}
                        <div class="col-12">
                            <label class="form-label">Ткань:</label>
                            <select class="form-control form-select" bind:value={material_group}>
                                {#each inner as group}
                                    <option value={group}>{group}</option>
                                {/each}
                            </select>
                        </div>
                    {/if}
                {/if}
            {/if}
        </div>

        {#if material_type}
            {@const items = data.result
                .filter((el) => ((material_type !== 'Вальс' && el.ind3 === material_type) || (material_type === 'Вальс' && el.ind3 === material_sub) || el.nameZvena === material_type || (material_sub === 'Ткань' && el.nameZvena === 'Ткани вальс' )) && (el.ind1 && material_type ? el.ind1 === material_group : true))
                .filter((el) => search.length ? el.name.toLowerCase().includes(search.toLowerCase()) : true)
                .map((el) => ({...el, opt_price: el.price3}))
            }

            {#if items.length}
                <div class="form-group searchbox my-3">
                    <input type="search" class="form-control" bind:value={search} placeholder="Поиск..">
                    <i class="input-icon">
                        <i class="fas fa-search"></i>
                    </i>
                </div>

                <MaterialsList
                        openedGroup="group"
                        list={Object.entries({group: items})}
                        {components}
                        {toggleComponent}
                        {setComponentCount}

                />
            {/if}
        {/if}
   </div>
{/await}
